import { Component, Inject, Optional } from '@angular/core';
import {
  FQAN_jedgrad_id,
  FQAN_razina,
  Razina
} from '@app/components/hierarhija/hierarhija.component';
import { IzvjestajDownloadService } from '@app/components/izvjestaji/services/izvjestaj-dowload-content.service';
import { AppConfig, appConfigService } from '@app/config';
import {
  DataSource,
  ItemProvider,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  ServerItemAction
} from '@ntap/core';
import { Observable, map, take } from 'rxjs';

@Component({
  selector: 'app-print-potvrda-primitka-action',
  template: `<button
    pButton
    ntapDebounceClick
    label="Preuzmi potvrdu"
    [disabled]="(enabled$ | async) === false"
    (onClick)="executeAction()"
  ></button>`
})
export class PrintPotvrdaPrimitkaActionComponent extends ServerItemAction {
  constructor(
    protected override notificationService: NotificationService,
    @Optional() protected override itemProvider: ItemProvider,
    protected override dataSource: DataSource,
    @Optional()
    protected override listViewProvider: ListViewProviderDirective<ListView>,
    protected documentsDownloadService: IzvjestajDownloadService,
    @Inject(appConfigService) private config: AppConfig
  ) {
    super(notificationService, itemProvider, dataSource, listViewProvider);
    this.config = config;
  }

  enabled$: Observable<boolean>;
  private baseUrl = this.config.apiHost;

  override initDisabledObservable(): void {
    this.isDisabled$ = this.itemProvider.item$.pipe(
      map((item: any) => {
        return item[FQAN_razina] < Razina.DOKUMENT;
      })
    );
  }

  override executeAction(): void {
    this.itemProvider?.item$.pipe(take(1)).subscribe((item: any) => {
      if (item) {
        const jedinicaGradivaId = item[FQAN_jedgrad_id];
        const posiljkaId = item['seup~posiljka~id'];
        const payload = {
          format: 'pdf',
          reportParams: {
            jedinica_gradiva_id: jedinicaGradivaId,
            posiljka_id: posiljkaId
          }
        };
        this.doDownload(payload).subscribe();
      }
    });
  }

  doDownload(body: any) {
    const url = `${this.baseUrl}print-potvrda-primitka-dokumenta`;
    return this.documentsDownloadService.previewReportByUrl(url, body);
  }
}
